"use client";

import * as React from "react";

import { RegisterStep, RegisterStepperProvider } from "./RegisterStepperProvider";
import { RegisterStepperHero, RegisterStepperLayout } from "./RegisterStepperLayout";

type Props = {
    /**
     * Used as the left hero title in `variant="split"`.
     * Kept for backwards compatibility.
     */
    title: string;
    steps: RegisterStep[];
    /**
     * If true, the stepper stays visible on confirmation step.
     * Otherwise the shell only renders children (no chrome).
     */
    showOnConfirmation?: boolean;
    variant?: "simple" | "split";
    hero?: RegisterStepperHero;
    type?: "user" | "provider";
    className?: string;
    initialStepKey?: string;
    onStepChange?: (key: string) => void;
    onClose?: () => void;
    children: React.ReactNode;
};

export default function RegisterStepper(props: Props) {
    const { steps, initialStepKey, onStepChange, title, showOnConfirmation, variant, hero, type, className, onClose, children } =
        props;

    return (
        <RegisterStepperProvider steps={steps} initialStepKey={initialStepKey} onStepChange={onStepChange}>
            <RegisterStepperLayout
                title={title}
                steps={steps}
                type={type}
                showOnConfirmation={showOnConfirmation}
                variant={variant}
                hero={hero}
                className={className}
                onClose={onClose}
            >
                {children}
            </RegisterStepperLayout>
        </RegisterStepperProvider>
    );
}

export { RegisterStepperProvider, useRegisterStepper } from "./RegisterStepperProvider";
export { RegisterStepperLayout } from "./RegisterStepperLayout";
export type { RegisterStep, RegisterStepperApi } from "./RegisterStepperProvider";
export type { RegisterStepperHero } from "./RegisterStepperLayout";
